export function useCreateBlockedTooltip() {
  const { t } = useI18n()

  const { isFreeUser } = storeToRefs(useUserStore())

  const createBlockedTooltip = computed(() =>
    isFreeUser.value ? t('global.navigation.tooltip.upload_blocked') : t('global.navigation.tooltip.create_blocked')
  )

  return { createBlockedTooltip }
}
